import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import ConfigurationUpload from '../../../_lib/components/ConfigurationFileUpload/ConfigurationUpload';
import { Namespace } from '../../../translation/namespace';

type PluginConfigurationEditProps = { form: IForm };

function PluginConfigurationEdit({ form }: PluginConfigurationEditProps) {
  return <ConfigurationUpload namespace={Namespace.PluginConfiguration} name="file" form={form} />;
}

export const PluginConfigurationEditView = asView(PluginConfigurationEdit);
export type PluginConfigurationEditView = ComponentProps<typeof PluginConfigurationEditView>;
